import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { relatedFilms } from "@/mocks/film";

export default function RelatedSection() {
  return (
    <section id="related" className="scroll-mt-32 bg-background-100 py-14 md:py-20">
      <div className="px-4 md:px-6">
        <Reveal>
          <SectionHeading
            index="08 / 同类推荐"
            title="看完这部，还想找类似的"
            desc="如果你喜欢这种把冲突藏在日常里的家庭剧情片，下面这几部在题材、结构或气质上可以顺着看下去。"
          />
        </Reveal>

        <div className="mt-8 md:mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {relatedFilms.map((film, index) => (
            <Reveal key={film.title} delay={(index % 3) * 80}>
              <article className="group h-full rounded-lg bg-background-50 border border-background-200 overflow-hidden">
                <div className="w-full aspect-[3/4] overflow-hidden bg-background-200">
                  <img
                    src={film.image}
                    alt={`推荐影片《${film.title}》氛围海报`}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-[1.04]"
                  />
                </div>
                <div className="p-5 md:p-6">
                  <div className="flex items-center gap-2.5 flex-wrap">
                    <h3 className="font-heading text-lg font-bold text-foreground-950">
                      {film.title}
                    </h3>
                    <span className="px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-900 text-xs font-label whitespace-nowrap">
                      {film.year}
                    </span>
                  </div>
                  <p className="mt-1 text-xs text-primary-700 font-label">{film.genre}</p>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">{film.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}